'use strict';
const $ = require('jquery');
const Slide = require('./slide');
const lang = require('../lang');
const template = require('../templates/video-slide.hbs');

module.exports = class extends Slide {
  constructor(context = {}) {
    context = $.extend({}, {title: lang.get('video_title')}, context);
    super(template, context);
    this.video_name = context.video_name;
    this.duration = context.duration;
    this._idletimer = _idletimer;
    this.on('afterEnter', this._disableNextButton);
    this.on('afterEnter', this._startVideo);
    this.on('afterEnter', this._stopIdleTimer);
  }

  _disableNextButton() {
    setTimeout(() => {
      $('.slideshow-btn-next').attr("disabled", true).removeAttr("data-nav-next href");
    }, 1000);
  }

  _enableNextButton() {
    $('#next-text').removeClass('hidden');
    $('#video1').addClass('video-hidden');
    $('.slideshow-btn-next').removeAttr("disabled").attr({"data-nav-next": true, "href": "#"});
  }

  _startVideo() {
    $('#video1 source').attr('src', this.video_name);
    const video = document.getElementById('video1');
    video.load();
    const videoStatus = document.getElementById('videoStatus');
    this._videoProgressInterval = setInterval(checkVideoProgress, 5000);
    let lastTime = 0;

    const checkVideoProgress = () => {
      // Check if the video has progressed at least 2 seconds
      if (video.currentTime <= lastTime + 2) {
        this._enableNextButton();
        videoStatus.innerText = 'Video error';
      }
      lastTime = video.currentTime;
    };

    video.addEventListener('playing', () => {
      if (!video.paused) {
        $('#video-loader').hide();
        $('#video1').removeClass('video-hidden');
        videoStatus.innerText = '';
        this._videoProgressInterval = setInterval(checkVideoProgress, 5000);
      }
    });

    const stopInterval = () => {
      $('#video-loader').hide();
      clearInterval(this._videoProgressInterval);
    };

    video.addEventListener('pause', () => {
      stopInterval();
    });

    video.addEventListener('ended', () => {
      videoStatus.innerText = '';
      this._enableNextButton();
      stopInterval();
    });

    video.addEventListener('error', () => {
      videoStatus.innerText = 'Video error';
      this._enableNextButton();
      stopInterval();
    });

    video.addEventListener('waiting', () => {
      videoStatus.innerText = 'Buffering...';
    });
  }

  _stopIdleTimer() {
    if (_idleintervalHandler != undefined) {
      clearInterval(_idleintervalHandler);
    }
  }
}
